/* External dependencies */
import { ICognitoUserPoolData } from 'amazon-cognito-identity-js';

/* Local dependencies */

export enum LoginActionTypes {
  LOGIN_REQUEST = 'LOGIN_REQUEST',
  LOGIN_ERROR = 'LOGIN_ERROR',
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
  SET_LOGIN_FIELD = 'SET_LOGIN_FIELD',
}

export interface LoginRequest {
  type: LoginActionTypes.LOGIN_REQUEST;
  username: string;
  password: string;
  userPool: ICognitoUserPoolData;
  phone?: string;
  [key: string]: any;
}

export interface LoginError {
  type: LoginActionTypes.LOGIN_ERROR;
  error: any;
  [key: string]: any;
}

export interface LoginSuccess {
  type: LoginActionTypes.LOGIN_SUCCESS;
  [key: string]: any;
}

export interface SetLoginField {
  type: LoginActionTypes.SET_LOGIN_FIELD;
  field: 'email' | 'password' | 'verificationCode' | 'phone';
  value: string;
  [key: string]: any;
}

export function login(email: string, password: string, userPool: ICognitoUserPoolData, phone: string): LoginRequest {
  return {
    type: LoginActionTypes.LOGIN_REQUEST,
    username: email,
    password,
    userPool,
    phone,
  } as LoginRequest;
}

export function loginFailed(error: any): LoginError {
  return {
    type: LoginActionTypes.LOGIN_ERROR,
    error,
  } as LoginError;
}

export function loginSucceeded(): LoginSuccess {
  return {
    type: LoginActionTypes.LOGIN_SUCCESS,
  } as LoginSuccess;
}

export function setLoginField(field: 'email' | 'password' | 'verificationCode' | 'phone', value: string): SetLoginField {
  return {
    type: LoginActionTypes.SET_LOGIN_FIELD,
    field,
    value,
  };
}

export type LoginAction = LoginRequest | LoginError | LoginSuccess | SetLoginField;
